import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useHasGroup } from '../../hooks/useHasGroup';

// Route guard: only renders `children` when the user is authenticated AND in
// (one of) the required `group`(s). Unauthenticated users are sent to /login;
// authenticated users without the group are redirected to `redirectTo` (default
// the GK Office dashboard) with a notice. Use to gate a whole area, e.g. wrap
// the layout element of /markt. For inline show/hide of an element, use HasGroup.
const RequireGroup = ({ group, children, redirectTo = '/' }) => {
  const isAuthenticated = useSelector((state) => state.auth.authenticated);
  const allowed = useHasGroup(group);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    } else if (!allowed) {
      toast.error('Kein Zugriff auf diesen Bereich.');
      navigate(redirectTo);
    }
  }, [isAuthenticated, allowed, navigate, redirectTo]);

  return isAuthenticated && allowed ? children : null;
};

export default RequireGroup;
